import * as React from 'react';

import { PresenceContext } from './PresenceContext';

export const useHardwarePresenceMembers = () =>
  React.useContext(PresenceContext).hardwareMembers;
